module.exports = __webpack_public_path__ + "symantec_ico@2x.0a0bc7472711ea6f94bf95aff6782fde.png";